import { ref, onMounted } from '@vue/composition-api'
import zonesApi from '@/services/api/zones'

export default function useZones() {
  const zones = ref([])
  const loading = ref(false)

  async function fetch() {
    loading.value = true
    try {
      const res = await zonesApi.list()
      zones.value = res.data.data
    } catch (_err) {
      // ignore
    } finally {
      loading.value = false
    }
  }

  onMounted(fetch)

  return { zones, loading }
}



// WEBPACK FOOTER //
// ./src/composables/useZones.js